import { render, staticRenderFns } from "./BlocPlan.vue?vue&type=template&id=47b5f0e4&scoped=true"
import script from "./BlocPlan.vue?vue&type=script&lang=js"
export * from "./BlocPlan.vue?vue&type=script&lang=js"
import style0 from "./BlocPlan.vue?vue&type=style&index=0&id=47b5f0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5f0e4",
  null
  
)

export default component.exports